<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
</script>

<div class="form-group">
  <select
    class="form-select"
    on:change={(e) => dispatch("update", e.target.value)}
  >
    <option value="" disabled>Select an option</option>
    <option value="7" selected>Last 7 Days</option>
    <option value="30">Last 30 Days</option>
    <option value="60">Last 60 Days</option>
    <option value="90">Last 90 Days</option>
  </select>
</div>
